import styles from "./IntegrationRequiredState.module.css";

const IntegrationRequiredState = ({ eyebrow, title, body, buttonLabel, onClick }) => {
  return (
    <section className={styles.card}>
      {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.body}>{body}</p>
      <button type="button" className={styles.button} onClick={onClick}>
        {buttonLabel}
      </button>
    </section>
  );
};

export default IntegrationRequiredState;
